import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Switch, Route, Redirect, BrowserRouter as Router } from 'react-router-dom';
import {Container} from 'reactstrap';
import CustomHeader from '../../components/CustomHeader';
import CustomFooter from '../../components/CustomFooter';
import GoogleLogin from '../../views/Login/GoogleLogin';
import LoginWithTAC from '../../views/Login/LoginWithTAC'
import TaskCategories from '../../views/TaskCategories';
import Dashboard from '../../views/Dashboard/';
import TaskAcceptance from '../../views/TaskAcceptance/';
import TaskRender from '../../views/TaskRender/';
import ProjectTasks from '../../views/ProjectTasks';
import * as actions from '../../redux/auth/actions'
import Analytics from 'react-router-ga'

//import * as actions from '../../redux/googleSession/actions';
//import * as twoFaActions from '../../redux/twofaAuth/actions'

const PrivateRoute = ({component: Component, authed, ...rest}) => {  
  return (    
       <Route {...rest} render={(props) => authed === true 
         ? <Component {...props} /> 
         : <Redirect to={{pathname: '/login', state: {from: props.location }}} />} />  
  )
}

const isLoggedIn = props => {
  const { auth } = props;
  
  if (auth.user ){
    return true;
  } else {
    return false;
  }
}

// const getProfile = props => {
//    const { gs,twofaAuth } = props;
//    if (gs.googleUser){
//       return gs.profile
//    }else {
//       return twofaAuth.user
//    }
// }

// const getLogout = props => {
//   const { gs } = props;
//   if (gs.googleUser){
//      return props.logout;
//   }else {
//      return props.twoFaLogout;
//   }
// }

const Full=props=>{
  return (
    <Router>
      <div className="app">
        <CustomHeader profile={props.auth.profile} logout={props.logout} />
        <div className="app-body">
          <main className="main">
            <Container>
              <Analytics id="UA-93381200-5">
               <Switch>
                  <Route path="/login" name="Login" component={GoogleLogin}/> 
                  <Route path="/loginWithTAC" name="Login" component={LoginWithTAC}/> 
                  <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/dashboard' component = {Dashboard} />
                  <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/taskAcceptance' component = {TaskAcceptance} />
                  <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/taskRender' component = {TaskRender} />
                  <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/projectTasks' component={ProjectTasks} />
                  <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/projectTasks/:taskCategoryId' component={ProjectTasks} />
                  <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/' component = {TaskCategories} />
                  <Route render={() => (
                        <div className='container'>
                          <div className='row'>
                              <h3>Are we lost or what?</h3>
                          </div> 
                        </div>
                  )}/>
               </Switch>   
              </Analytics> 
            </Container>  
          </main>
        </div>
        <CustomFooter />
      </div>
    </Router>  
  )
}

const mapStateToProps = (state) => {
  return state;
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    logout: () => {
      dispatch(actions.logout())
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Full);



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js